import { warning } from 'hey-listen';

export const errorHandler = ({ error }: { error: any }) => {
  warning(false, error);
};
